import { useState } from 'react';

export interface FaqEntry {
  q: string;
  a: string;
}

export default function FaqOrgaosPublicos({ items }: { items: FaqEntry[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div
            key={item.q}
            className={`bg-white rounded-2xl border transition-colors duration-200 ${
              isOpen ? 'border-primary-200' : 'border-background-200'
            }`}
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer group"
            >
              <span
                className={`text-[14px] md:text-[15px] font-medium leading-snug transition-colors ${
                  isOpen ? 'text-primary-700' : 'text-foreground-900 group-hover:text-primary-600'
                }`}
              >
                {item.q}
              </span>
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                  isOpen ? 'bg-primary-600 text-white rotate-180' : 'bg-background-100 text-foreground-500'
                }`}
              >
                <i className="ri-arrow-down-s-line text-base"></i>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 md:px-6 pb-5">
                <div className="border-t border-background-200 pt-4">
                  <p className="text-[13px] md:text-[14px] text-foreground-500 font-light leading-relaxed">{item.a}</p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}